module.exports = __webpack_public_path__ + "img/13.dc94f496.jpg";